var bittoelatings_i = [{
    rule: "payroll:create",
    bitmask: "1",
    blok: 8,
    beskrywing: "Koppel van payroll stelsel integrasie",
    groepe: ["payroll"],
},
{
    rule: "payroll:read",
    bitmask: "2",
    blok: 8,
    beskrywing: "Lees van payroll stelsel integrasie",
    groepe: ["payroll"],
},
{
    rule: "payroll:update",
    bitmask: "4",
    blok: 8,
    beskrywing: "Verander van payroll stelsel integrasie",
    groepe: ["payroll"],
},
{
    rule: "payroll:delete",
    bitmask: "8",
    blok: 8,
    beskrywing: "Verwyder van payroll stelsel integrasie",
    groepe: ["payroll"],
},
{
    rule: "payrolldata:read",
    bitmask: "16",
    blok: 8,
    beskrywing: "Lees van payroll stelsel integrasie inligting",
    groepe: ["payroll"],
},
{
    rule: "rekening:verbruik",
    bitmask: "32",
    blok: 8,
    beskrywing: "Stelselverbruik en -koste sien",
    groepe: ["rekening"],
},
{
    rule: "rekening:settings",
    bitmask: "64",
    blok: 8,
    beskrywing: "Rekening verstellings maak",
    groepe: ["rekening"],
},
{
    rule: "rekening:bills",
    bitmask: "128",
    blok: 8,
    beskrywing: "Rekeninge sien",
    groepe: ["rekening"],
},
];

export default bittoelatings_i;